import React, { useState } from "react";
import Sidebar from "../../components/Sidebar/Sidebar";
import Footer from "../../components/Footer/Footer";
import HealthSummary from "../../components/Library/HealthSummary";
import Articles from "../../components/Library/Articles";
import BMIModal from "../../components/Library/BMIModal";
import VideoGuides from "../../components/Library/VideoGuides";
import AdvanceDirectiveArticles from "../../components/Library/AdvanceDirectiveArticles";

const Library = () => {
  const [sidebarExpanded, setSidebarExpanded] = useState(true);
  const [showModal, setShowModal] = useState(false);

  const userId = localStorage.getItem("userId");

  return (
    <div className={`ml-0 flex flex-col min-h-screen transition-all duration-300 ${sidebarExpanded ? 'md:ml-56' : 'md:ml-16'}`}>
      <Sidebar expanded={sidebarExpanded} setExpanded={setSidebarExpanded} />

      <main className="flex-1 p-6 overflow-auto bg-gray-100">
        <HealthSummary userId={userId} />

        <h2 className="text-2xl font-bold mb-4 text-[#04395b]">Educational Content</h2>

        <h3 className="text-xl font-semibold mb-2 text-[#04395b]">Advance Directives</h3>
        <AdvanceDirectiveArticles />

        <h3 className="text-xl font-semibold mb-2 text-[#04395b]">Articles</h3>
        <Articles userId={userId} />

        <h3 className="text-xl font-semibold mb-2 text-[#04395b]">Video Guides</h3>
        <VideoGuides userId={userId} />

        <section>
          <h2 className="text-2xl font-bold my-4 text-[#04395b]">Interactive Tools</h2>
          <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
            <div className="p-6 bg-white border border-gray-200 shadow-md rounded-xl">
              <h4 className="text-lg font-semibold text-[#04395b]">Heart Risk Assessment</h4>
              <p className="mt-2 text-sm text-gray-600">Estimate your cardiovascular risk.</p>
            </div>
            <button onClick={() => setShowModal(true)} className="p-6 bg-white border border-gray-200 shadow-md rounded-xl flex flex-col items-start hover:bg-gray-50">
              <h4 className="text-lg font-semibold text-[#04395b]">BMI Calculator</h4>
              <p className="mt-2 text-sm text-gray-600">BMI</p>
            </button>
          </div>
        </section>
      </main>
      <Footer />

      <BMIModal isOpen={showModal} onClose={() => setShowModal(false)} />
    </div>
  );
}

export default Library;